var modules_b3384f04 = {"container":"TableView_module_container__e9d0566f","table":"TableView_module_table__e9d0566f"};
import "../../../assets/esm/components/Table/src/TableView~CkmL79_g.css";

export { modules_b3384f04 as default };
//# sourceMappingURL=TableView.module.less.js.map
